import store from '@/store/store'

export function guardUser (to, from, next) {
  // check User with Auth-Firebase???
  if (store.getters.user !== null && store.getters.user !== undefined) {
    console.log('AuthGuard_UserIsLoggedIn', store.getters.user)
    next()
  } else {
    console.log('AuthGuard_NotLoggedIn_RedirectToAuthPage', store.getters.user)
    next('/')
  }
}